import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import retraite from "../../../../../../../assets/images/svg/111-rocking-chair.png";
import activite from "../../../../../../../assets/images/svg/035-id-card.svg";
import pole from "../../../../../../../assets/images/svg/066-job-interview.svg";
import autre from "../../../../../../../assets/images/svg/034-clipboard.svg";
import home from "../../../../../../../assets/images/svg/069-home.svg";
import university from "../../../../../../../assets/images/svg/146-university.png";
import {ProfessionOptions} from '../../../../../../../constants/utils/connectionTypes';
import {updateRelocationDeclaration} from '../../../../../../../actions/events-api';
import * as loadings from '../../../../../../../constants/loadings/relocationDeclaration';
import * as R from 'ramda';
import $ from 'jquery';

export const FormSituationPro = ({ relocationDeclaration, userId, isLoading, setEditMode, getDeclaration }) => {
	const dispatch = useDispatch();
	const activityForm = useRef(null);
	const [professionSelected, setProfessionSelected] = useState(relocationDeclaration.professionalSituation);
	return (
		<div className="card">
			<div className="card-body scroll-default py-0">
				<p className="o-60">Modifier les informations qui ne sont pas à jour.</p>
				<form className="flex-column" ref={activityForm}>
					<div className="form-row">
						<div className="form-group col col-lg">
							<div
								className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.active) ? " active" : "")}
								onClick={() => {
									if (!professionSelected.includes(ProfessionOptions.active) && !professionSelected.includes(ProfessionOptions.unemployed) && !professionSelected.includes(ProfessionOptions.none)) {
										setProfessionSelected([...professionSelected.slice(), ProfessionOptions.active]);
									} else {
										setProfessionSelected([...professionSelected.filter((p) => p !== ProfessionOptions.active)]);
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={activite} alt="activite" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">EN ACTIVITÉ(E)</h2>
							</div>
						</div>
						<div className="form-group col col-lg">
							<div
								className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.retired) ? " active" : "")}
								onClick={() => {
									if (!professionSelected.includes(ProfessionOptions.retired) && !professionSelected.includes(ProfessionOptions.unemployed) && !professionSelected.includes(ProfessionOptions.none)) {
										setProfessionSelected([...professionSelected.slice(), ProfessionOptions.retired]);
									} else {
										setProfessionSelected([...professionSelected.filter((p) => p !== ProfessionOptions.retired)]);
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={retraite} alt="retraite" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">RETRAITÉ(E)</h2>
							</div>
						</div>

						<div className="form-group col col-lg">
							<div
								className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.unemployed) ? " active" : "")}
								onClick={() => {
									if (!professionSelected.includes(ProfessionOptions.unemployed) && !professionSelected.includes(ProfessionOptions.active) && !professionSelected.includes(ProfessionOptions.retired) && !professionSelected.includes(ProfessionOptions.none)) {
										setProfessionSelected([...professionSelected.slice(), ProfessionOptions.unemployed]);
									} else {
										setProfessionSelected([...professionSelected.filter((p) => p !== ProfessionOptions.unemployed)]);
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={pole} alt="pole" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">À FRANCE TRAVAIL</h2>
							</div>
						</div>
						<div className="form-group col col-lg">
							<div
								className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.other) ? " active" : "")}
								onClick={() => {
									if (!professionSelected.includes(ProfessionOptions.other) && !professionSelected.includes(ProfessionOptions.none)) {
										setProfessionSelected([...professionSelected.slice(), ProfessionOptions.other]);
									} else {
										setProfessionSelected([...professionSelected.filter((p) => p !== ProfessionOptions.other)]);
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={autre} alt="autre" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">autre</h2>
							</div>
						</div>
						<div className="form-group col col-lg">
							<div
								className={"card card-body text-center picker-card" + (professionSelected?.includes(ProfessionOptions.none) ? " active" : "")}
								onClick={() => {
									if (!professionSelected?.includes(ProfessionOptions.none)) {
										setProfessionSelected([ProfessionOptions.none]);
									} else {
										setProfessionSelected([...professionSelected?.filter((p) => p !== ProfessionOptions.none)]);
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={home} alt="autre" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Sans activité</h2>
							</div>
						</div>
						<div className="form-group col col-lg">
							<div
								className={"card card-body text-center picker-card" + (professionSelected.includes(ProfessionOptions.student) ? " active" : "")}
								onClick={() => {
									if (!professionSelected.includes(ProfessionOptions.student)) {
										setProfessionSelected([ProfessionOptions.student]);
									} else {
										setProfessionSelected([...professionSelected.filter((p) => p !== ProfessionOptions.student)]);
									}
								}}>
								<img className="img-fluid mx-auto my-3 mb-2 h-6" src={university} alt="student" />
								<h2 className="h6 font-weight-bolder text-uppercase mb-auto">Étudiant(e)</h2>
							</div>
						</div>
						<div className={"invalid-feedback alert-danger alert" + (professionSelected.length === 0 && !R.isNil(activityForm.current) && activityForm.current.classList.contains("was-validated") ? " d-block" : "")}>Veuillez choisir une option</div>
					</div>
				</form>
			</div>
			<div className="card-footer">
				<button
					type="button"
					className="btn btn-light mr-2"
					onClick={() => {
						setEditMode(false);
					}}>
					Annuler
				</button>
				{isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
					<button type="button" className="btn btn-info loading-btn show">
						<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
					</button>
				) : (
					<button
						type="button"
						className="btn btn-info"
						disabled={professionSelected.length === 0}
						onClick={(e) => {
							e.preventDefault();
							activityForm.current.classList.add("was-validated");
							if (activityForm.current.checkValidity()) {
								dispatch(
									updateRelocationDeclaration(userId, {
										...relocationDeclaration,
										professionalSituation: professionSelected,
									})
								).then(() => {
									setEditMode(false);
									getDeclaration();
								});
							}
						}}>
						Sauvegarder
					</button>
				)}
			</div>
		</div>
	);
};